import InputModal from "../../../../../components/leave-management/InputModal/InputModal.vue";
import  ImportModal from "../../../../../components/leave-management/ImportModal.vue";
export default {
  name: "BonusLeaveImportExcel",
  props: {
    formData: {
      type: Object,
      default: function() {
        return {};
      },
    },

    historyList: {
      type: Array,
      default: function() {
        return [{}];
      },
    },

    displayFields: {
      type: Array,
      default: [],
    },
    handleFormatData: Function,
  },
  components: { InputModal, ImportModal },
  data() {
    return {
      // handle show modal
      isVisibleModal: false,
      historyDisplay: [],
      visibleModalImport: true,
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.historyDisplay = this.mappingDisplayData(this.formData);
  },
  methods: {
    /**
     * Import excel file
     * @returns 
     */
    handleOk() {
      return true;
    },

    onCancel() {
      this.visibleModal = false;
      this.visibleModalImport = false;
    },
  },
  destroyed() {},
};
